import { render } from "./BaseInputCode.vue?vue&type=template&id=5fa21db4"
import script from "./BaseInputCode.vue?vue&type=script&lang=js"
export * from "./BaseInputCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__